import { Box, Text } from '@simplywallst/ui-core';
import SnowflakeConfig from '../SnowflakeConfig';
import { KeywordSearch } from './components/KeywordSearch';
import { pluralise } from '@/utilities/pluralise';
import {
  MainGrid,
  SnowflakeGrid,
  FiltersGrid,
  KeywordsGrid,
  TagsContainer,
} from './styled';
import Tags from '../Tags';

interface Props {
  snowflakeScore: number[];
  onSnowflakeChange: (points: number[]) => void;
  onShowMarketModal: () => void;
  onShowIndustryModal: () => void;
  onShowFiltersModal: () => void;
  keywords?: string;
  onKeywordChange: (keywords: string) => void;
  selectedMarkets: string[];
  selectedIndustries: string[];
  selectedFilters: string[];
}
export function Filters({
  snowflakeScore,
  onSnowflakeChange,
  onShowMarketModal,
  onShowIndustryModal,
  onShowFiltersModal,
  onKeywordChange,
  keywords,
  selectedMarkets,
  selectedIndustries,
  selectedFilters,
}: Props) {
  function createFilterLabel(
    items?: readonly string[],
    type: 'market' | 'industry' | 'filter' = 'filter'
  ) {
    let sentence = '';
    if (typeof items !== 'undefined' && items.length > 0) {
      sentence = `${items.length} ${pluralise(
        items.length,
        'filter',
        'filters'
      )}`;
    }
    if (sentence !== '') {
      return sentence;
    } else {
      if (type === 'market') {
        return 'All markets';
      } else if (type === 'industry') {
        return 'All industries';
      } else {
        return `Add filter`;
      }
    }
  }
  return (
    <Box
      paddingLeft="x2spacePx"
      paddingRight="x2spacePx"
      paddingBottom="x2spacePx"
      paddingTop="x2spacePx"
      backgroundColor="noir"
      borderRadius="x2"
    >
      <MainGrid>
        <SnowflakeGrid>
          <Text typography="xSmallStrong">Snowflake Filter</Text>
          <Box paddingLeftMd="x4spacePx" paddingRightMd="x4spacePx">
            <SnowflakeConfig
              score={snowflakeScore}
              onChange={onSnowflakeChange}
            />
          </Box>
        </SnowflakeGrid>
        <FiltersGrid>
          <Box
            borderRadius="x1spacePx"
            padding="x1spacePx"
            paddingMd="x2spacePx"
            onClick={onShowMarketModal}
            style={{
              backgroundColor: 'var(--s-color-surface-2)',
              cursor: 'pointer',
            }}
          >
            <Text typography="xSmallStrong">Markets</Text>
            <Text typography="tiny" color="brand01">
              {createFilterLabel(selectedMarkets, 'market')}
            </Text>
            <TagsContainer>
              <Tags
                list={selectedMarkets.slice(0, 5)}
                concat={selectedMarkets.length >= 5}
                onClick={onShowMarketModal}
              />
            </TagsContainer>
          </Box>
          <Box
            borderRadius="x1spacePx"
            padding="x1spacePx"
            paddingMd="x2spacePx"
            onClick={onShowIndustryModal}
            style={{
              backgroundColor: 'var(--s-color-surface-2)',
              cursor: 'pointer',
            }}
          >
            <Text typography="xSmallStrong">Industry</Text>
            <Text typography="tiny" color="brand01">
              {createFilterLabel(selectedIndustries, 'industry')}
            </Text>
            <TagsContainer>
              <Tags
                list={selectedIndustries.slice(0, 5)}
                concat={selectedIndustries.length >= 5}
                onClick={onShowIndustryModal}
              />
            </TagsContainer>
          </Box>
          <Box
            backgroundColor="noir"
            borderRadius="x1spacePx"
            padding="x1spacePx"
            paddingMd="x2spacePx"
            onClick={onShowFiltersModal}
            style={{
              backgroundColor: 'var(--s-color-surface-2)',
              cursor: 'pointer',
            }}
          >
            <Text typography="xSmallStrong">Metrics</Text>
            <Text typography="tiny" color="brand01">
              {createFilterLabel(selectedFilters, 'filter')}
            </Text>
            <TagsContainer>
              <Tags
                list={selectedFilters.slice(0, 6)}
                concat={selectedFilters.length >= 6}
                onClick={onShowMarketModal}
              />
            </TagsContainer>
          </Box>
        </FiltersGrid>
        <KeywordsGrid>
          <KeywordSearch keywords={keywords} onChange={onKeywordChange} />
        </KeywordsGrid>
      </MainGrid>
    </Box>
  );
}
